/**
 * @flow
 * @relayHash 78856c548e025296f6ef66e42f87c682
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type MainOrderEditInput = {
  fromId: string,
  toId: string,
  fromIndex?: ?number,
  toIndex?: ?number,
};
export type MainOrderEditMutationVariables = {|
  input: MainOrderEditInput
|};
export type MainOrderEditMutationResponse = {|
  +MainOrderEdit: ?{|
    +error: ?string
  |}
|};
export type MainOrderEditMutation = {|
  variables: MainOrderEditMutationVariables,
  response: MainOrderEditMutationResponse,
|};
*/


/*
mutation MainOrderEditMutation(
  $input: MainOrderEditInput!
) {
  MainOrderEdit(input: $input) {
    error
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "input",
    "type": "MainOrderEditInput!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "MainOrderEdit",
    "storageKey": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input",
        "type": "MainOrderEditInput!"
      }
    ],
    "concreteType": "MainOrderEditPayload",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "error",
        "args": null,
        "storageKey": null
      }
    ]
  }
];
return {
  "kind": "Request",
  "operationKind": "mutation",
  "name": "MainOrderEditMutation",
  "id": null,
  "text": "mutation MainOrderEditMutation(\n  $input: MainOrderEditInput!\n) {\n  MainOrderEdit(input: $input) {\n    error\n  }\n}\n",
  "metadata": {},
  "fragment": {
    "kind": "Fragment",
    "name": "MainOrderEditMutation",
    "type": "Mutation",
    "metadata": null,
    "argumentDefinitions": v0,
    "selections": v1
  },
  "operation": {
    "kind": "Operation",
    "name": "MainOrderEditMutation",
    "argumentDefinitions": v0,
    "selections": v1
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '7f35b1ef1fae84ef3971296c2bf8d8a5';
module.exports = node;



// WEBPACK FOOTER //
// src/mutations/__generated__/MainOrderEditMutation.graphql.js